import { Album } from '@Techedge/digitalportal-shared'
import DistributionList from '../ActivityCreation/Distribution/DistributionList'
import {
    Color,
    LuxButton,
    LuxMultiSelect,
    LuxRadioInput,
    LuxUserAvatar,
    LuxTextInput,
} from '@lux/wardrobe-lib'
import { useIntl } from 'react-intl'
import { GalleryService } from '@/app/services/GalleryService'
import { SearchByValues } from '@/app/models/photo'
import { useRef, useState } from 'react'
import { OverlayPanel } from 'primereact/overlaypanel'

const AlbumsDistribution = (props: {
    albumDetails: Album
    setAlbumDetails: (a: Album) => void
    userSearchError: (error: string) => void
    visibilityList: any[]
    distributionAction: any
    distributionChangeHandler: any
}) => {
    const {
        albumDetails,
        setAlbumDetails,
        userSearchError,
        visibilityList,
        distributionAction,
        distributionChangeHandler,
    } = props
    const intl = useIntl()

    const [searchBy, setSearchBy] = useState<SearchByValues>(SearchByValues.USER_ID)
    const [searchField, setSearchField] = useState<string>('')
    const [userList, setUserList] = useState<any[]>([])
    const [userLoading, setUserLoading] = useState<boolean>(false)

    const [smartFilter, setSmartFilter] = useState<any>({})

    const panelRef = useRef(null)

    const onUserSearch = (searchBy: SearchByValues, value: string, e: Event) => {
        setUserLoading(true)
        GalleryService.GetSearchUserList(searchBy, value.toUpperCase())
            .then((res: any) => {
                if (res && res.data && !res.data.output) {
                    setUserList(
                        res.data.userList.map((u: any) => ({
                            ...u,
                            userName: `${u.nickname ? u.nickname : u.firstname}${u.nickname ? '' : ' ' + u.lastname}`,
                        }))
                    )
                    setUserLoading(false)
                    panelRef.current.show(e)
                }
            })
            .catch((err) => {
                userSearchError(err.message)
                setUserLoading(false)
            })
    }

    return (
        <div>
            <LuxMultiSelect
                classes="mb-3"
                value={albumDetails.distribution?.roles}
                onChangeCallback={(v: any) =>
                    setAlbumDetails({
                        ...albumDetails,
                        distribution: { ...albumDetails.distribution, roles: v },
                    })
                }
                label={intl.formatMessage({
                    id: 'modals.link_visibility_by_role_label',
                    defaultMessage: 'Visibility by Role',
                })}
                placeholder={intl.formatMessage({
                    id: 'modals.new_resource.visibility.placeholder',
                    defaultMessage: 'Select role',
                })}
                options={visibilityList?.map((visibility: { value: string; label: string }) => ({
                    ...visibility,
                    label: intl.formatMessage({
                        id: visibility.label,
                        defaultMessage: visibility.label.split('.').pop(),
                    }),
                }))}
                additionalProps={{
                    appendTo: 'self',
                }}
            />
            <DistributionList
                form={distributionAction.distributionModel}
                onSetForm={distributionChangeHandler}
                smartFilter={{}}
                setSmartFilter={setSmartFilter}
            />
            <div className="form-label my-3">
                {intl.formatMessage({ defaultMessage: 'Hide people', id: 'ph2.modals.hide_people' })}
            </div>
            <LuxRadioInput
                name="search_by"
                value={searchBy}
                radioList={[
                    {
                        label: intl.formatMessage({
                            id: 'search.by_user_id',
                            defaultMessage: 'By user ID',
                        }),
                        value: SearchByValues.USER_ID,
                    },
                    {
                        label: intl.formatMessage({
                            id: 'search.by_store_id',
                            defaultMessage: 'By store ID',
                        }),
                        value: SearchByValues.STORE_ID,
                    },
                ]}
                onChangeCallback={(val: SearchByValues) => setSearchBy(val)}
            />
            <div className="mt-3 flex w-100 align-items-center">
                <div className="col-10">
                    <LuxTextInput value={searchField} onChangeCallback={setSearchField} />
                    <OverlayPanel
                        appendTo={'self'}
                        ref={panelRef}
                        dismissable
                        className="albums-distribution-people-list-panel">
                        {userList.map((u) => (
                            <div
                                className="user-names"
                                onClick={() => {
                                    setSearchField('')
                                    let userExists = albumDetails.distribution.people?.find(
                                        (p) => p.userId === u.userId
                                    )
                                    if (!userExists)
                                        setAlbumDetails({
                                            ...albumDetails,
                                            distribution: {
                                                ...albumDetails.distribution,
                                                people: albumDetails.distribution.people
                                                    ? [...albumDetails.distribution.people, u]
                                                    : [u],
                                            },
                                        })
                                }}>
                                {u.userName}
                            </div>
                        ))}
                    </OverlayPanel>
                </div>
                <LuxButton
                    variant="outlined"
                    text={intl.formatMessage({
                        id: 'search',
                        defaultMessage: 'Search',
                    })}
                    classes="ml-3"
                    loading={userLoading}
                    color={Color.BLUE}
                    onClick={(e: Event) => onUserSearch(searchBy, searchField, e)}
                />
                {/* <LuxAutocomplete
                    value={searchField}
                    onPredictionSelected={(v) => {
                        setSearchField('')
                        setAlbumDetails({
                            ...albumDetails,
                            distribution: {
                                ...albumDetails.distribution,
                                people: albumDetails.distribution.people
                                    ? [...albumDetails.distribution.people, v]
                                    : [v],
                            },
                        })
                    }}
                    predictions={userList}
                    onChangeCallback={setSearchField}
                    minDigit={3}
                    // onSearchPredictions={(v) => setTimeout(() => onUserSearch(searchBy, v), 1000)}
                    onKeyUp={() => onUserSearch(searchBy, searchField)}
                    optionLabel={'userName'}
                    optionValue={'userId'}
                    additionalProps={{ appendTo: 'self' }}
                /> */}
            </div>
            <div className="mt-3">
                {albumDetails.distribution.people?.map((u) => (
                    <div key={u.userId} className="flex align-items-center justify-content-between">
                        <div className="flex align-items-center">
                            <LuxUserAvatar
                                userName={u.firstname}
                                userLastname={u.lastname}
                                userNickname={u.nickname}
                                avatarImage={u.attachment?.url}
                                size={24}
                            />
                            <span className="ml-2">{`${u.firstname} ${u.lastname}`}</span>
                        </div>
                        <LuxButton
                            variant="text"
                            text={intl.formatMessage({
                                defaultMessage: 'Remove',
                                id: 'ph2.modals.remove_user',
                            })}
                            color={Color.BLUE}
                            onClick={() =>
                                setAlbumDetails({
                                    ...albumDetails,
                                    distribution: {
                                        ...albumDetails.distribution,
                                        people: albumDetails.distribution.people.filter(
                                            (user) => user.userId !== u.userId
                                        ),
                                    },
                                })
                            }
                        />
                    </div>
                ))}
            </div>
        </div>
    )
}

export default AlbumsDistribution
